{
  "fr": {
    "validations": {
      "required": "Le champ %{field} est requis",
      "min": "Le champ %{field} doit comporter au moins %{min} caractères",
      "max": "Le champ %{field} doit comporter au plus %{max} caractères",
      "alpha_dash": "The %{field} field may contain alpha-numeric characters as well as dashes and underscores",
      "email": "Le champ %{field} doit être une adresse e-mail valide",
      "confirmed": "Le champ %{field} ne correspond pas",
      "numeric": "Le champ %{field} ne peut contenir que des caractères numériques",
      "between": "Le champ %{field} doit être entre %{min} et %{max}",
      "min_value": "Le champ %{field} doit être %{min} ou plus",
      "url": "Le champ %{field} n'est pas une URL valide"
    }
  }
}
